/*eslint-disable*/
export const propsFilters = {
  "extraFilters": {
    "enabled": true,
    "filters": [
      {
        "title": "Ticket",
        "type": "text",
        "minLength": 3,
        "column": "code"
      },
      {
        "title": "Ticket",
        "type": "text",
        "minLength": 3,
        "column": "code"
      }
    ]
  },
  "savedFilters": {
    "enabled": true,
    "endpoint": "https://www.mocky.io/v2/5bf8050b3100004b0000d31d",
    "filters": [
      {
        "name": "b1",
        "filters": [
          {
            "title": "Status",
            "type": "list",
            "column": "status",
            "handle": "bodyfilter_select_status",
            "values": "new"
          }
        ],
        "uuid": "99f769e4-c023-4760-a9b4-42374553b207"
      },
      {
        "name": "b2",
        "filters": [
          {
            "title": "Status",
            "type": "list",
            "column": "status",
            "handle": "bodyfilter_select_status",
            "values": "old"
          }
        ],
        "uuid": "ceb11c58-4b9e-47f6-b6ba-594b89db015b"
      }
    ]
  },
  "quickFilters": [
    {
      "title": "Quickfilter 3",
      "content": [
        {
          "column": "subject",
          "title": "Subject",
          "type": "list",
          "values": "Testing;chekc;dfsdf"
        }
      ],
      "uuid": "e4af9c13-d17c-4953-9904-74899b216352"
    },
    {
      "title": "QuickFilter 2",
      "content": [
        {
          "type": "daterange",
          "values": "20180326;20180328",
          "handle": "100027",
          "column": "createdDate"
        },
        {
          "type": "dateselector",
          "values": "20180325;20180329",
          "handle": "100028",
          "column": "updatedDate"
        }
      ],
      "default": false,
      "uuid": "b48eff62-79d0-4e35-95af-bf40c94883aa"
    },
    {
      "title": "Code 123",
      "uuid": "f70e29ad-a96d-48b7-9e6d-d711f1c93f1d",
      "content": [
        {
          "type": "search",
          "column": "code",
          "handle": "bodyfilter_text_code",
          "values": "06296839"
        }
      ]
    },
    {
      "title": "Code 123",
      "uuid": "19f6c75a-4764-4d86-a004-94c55a8c5b14",
      "content": [
        {
          "type": "search",
          "column": "code",
          "handle": "bodyfilter_text_code",
          "values": "06296839"
        }
      ]
    }
  ],
  "headers": [
    {
      "title": "Updated",
      "width": 250,
      "datafield": "updatedDate",
      "displayFormat": {
        "enabled": true,
        "type": "date",
        "format": "DD/MM/YYYY"
      },
      "sortable": {
        "enabled": true,
        "sortType": "date",
        "sortOrderOptions": {
          "UP": "Ascending",
          "DOWN": "Descending"
        }
      },
      "filters": {
        "title": "Updated",
        "type": "dateselector",
        "column": "updatedDate",
        "dateselector": {
          "headers": [
            {
              "label": "Single Date Label",
              "options": [
                {
                  "value": "today",
                  "label": "Today"
                },
                {
                  "label": "Specific date",
                  "value": "dateSingle"
                }
              ],
              "name": "singleDate"
            },
            {
              "label": "Date Range Label",
              "options": [
                {
                  "value": "30",
                  "label": "Last 30 days"
                },
                {
                  "label": "Specific Date Range",
                  "value": "dateRange"
                }
              ],
              "name": "multiDate"
            }
          ],
          "i18n": {
            "header_placeholder": "Select a new date value JSON"
          },
          "datePicker": {
            "dateFormat": "DD/MM/YYYY",
            "preventFutureDates": true,
            "datePickerFromName": "PickerFromName_926278422",
            "datePickerToName": "PickerToName_926278422",
            "datePickerName": "PickerName_926278422",
            "locale": "en",
            "i18n": {
              "invalid_from_date": "Please enter a valid 'From' date",
              "invalid_to_date": "Please enter a valid 'To' date",
              "invalid_date_range": "Please enter a valid date range",
              "invalid_from_future_date": "Future 'From' date is not allowed",
              "invalid_to_future_date": "Future 'To' date is not allowed",
              "invalid_date": "Please enter a valid date",
              "invalid_future_date": "Future date is not allowed",
              "placeholder": "Dateplaceholder",
              "from_placeholder": "From Dateplaceholder",
              "today_link": "Today"
            }
          },
          "name": "Dropdown",
          "multiheaderEnabled": true
        }
      },
      "cellLink": {
        "enabled": true,
        "callback": "cellLink"
      }
    },
    {
      "title": "Subject",
      "titleHelperText": "This is a helpertext tooltip to be shown on the Table header",
      "showToolTip": true,
      "datafield": "subject",
      "width": 200,
      "sortable": {
        "enabled": true,
        "sortType": "lexical",
        "sortOrderOptions": {
          "UP": "Ascending",
          "DOWN": "Descending"
        }
      },
      "filters": {
        "title": "Subject",
        "type": "select",
        "values": "EXTRACT",
        "column": "subject",
        "typeAheadEnabled": true,
        "multiSelectEnabled": true,
        "expand": true,
        "placeholderText": "Select Multiple values",
        "listOpenPlaceholderText": "Search in list"
      },
      "subRowOverride": {
        "enabled": true
      },
      "cellFormatter": {
        "enabled": true,
        "comparator": "cellFormatter"
      }
    },
    {
      "title": "Product",
      "showToolTip": false,
      "width": 200,
      "datafield": "product",
      "sortable": {
        "enabled": true,
        "sortType": "lexical",
        "sortOrderOptions": {
          "UP": "Ascending",
          "DOWN": "Descending"
        }
      },
      "cellLink": {
        "enabled": true,
        "callback": "cellLink"
      },
      "filters": {
        "title": "Product",
        "type": "select",
        "values": "EXTRACT",
        "column": "product"
      }
    },
    {
      "title": "Status",
      "datafield": "status",
      "width": 200,
      "sortable": {
        "enabled": true,
        "sortType": "lexical",
        "sortOrderOptions": {
          "UP": "Ascending",
          "DOWN": "Descending"
        }
      },
      "filters": {
        "title": "Status",
        "type": "select",
        "values": [
          {
            "value": "new",
            "label": "New"
          },
          {
            "value": "old",
            "label": "Old"
          },
          {
            "value": "dave",
            "label": "Dave"
          }
        ],
        "column": "status"
      },
      "cellFormatter": {
        "enabled": true,
        "comparator": "cellFormatter"
      }
    },
    {
      "title": "Ticket",
      "datafield": "code",
      "width": 200,
      "sortable": {
        "enabled": true,
        "sortType": "numeric",
        "sortOrderOptions": {
          "UP": "Ascending",
          "DOWN": "Descending"
        }
      },
      "filters": {
        "title": "Ticket",
        "type": "text",
        "minLength": 3,
        "column": "code"
      }
    },
    {
      "title": "Created",
      "datafield": "createdDate",
      "width": 200,
      "sortable": {
        "enabled": true,
        "sortType": "date",
        "sortOrderOptions": {
          "UP": "Ascending",
          "DOWN": "Descending"
        }
      },
      "filters": {
        "title": "Created",
        "type": "daterange",
        "column": "createdDate"
      },
      "displayFormat": {
        "enabled": true,
        "type": "date",
        "format": "DD/MM/YYYY"
      },
      "cellLink": {
        "enabled": true,
        "callback": "cellLink"
      }
    }
  ],
  "i18n": {
    "selectRange": "Select range",
    "selectFileFormat": "Select a file format",
    "filter": "Filter",
    "download": "Download",
    "downloadConfirm": "Download exceeds limit",
    "downloadConfirmMessage": "You have requested to download more than ${0} records. You can click \"Continue\" to start download or \"Cancel\" to refine your download request.",
    "apply": "Apply",
    "cancel": "Cancel",
    "next": "Next",
    "continue": "Continue",
    "previous": "Prev",
    "quickFilters": "Quick filters",
    "savedFilters": "Saved filters",
    "columnFilters": "Column filters",
    "applyFilter": "Apply filters",
    "saveFilters": "Save filters",
    "clearAll": "Clear all",
    "saveFilter": "Save Filter",
    "pleaseName": "Please name this filter to save",
    "name": "Name",
    "save": "Save",
    "continueWithoutSaving": "Continue without saving",
    "noSavedFilters": "No saved filters",
    "noResultsFilters": "There are 0 results for the filters applied, ",
    "clearFilters": "clear filters",
    "andTryAgain": " and try again.",
    "noResults": "No results",
    "search": "Search ${0}",
    "extraFilters": "Extra Filters",
    "selectValue": "Select a value",
    "select_from_date": "from",
    "select_to_date": "to",
    "invalid_from_date": "Please enter a valid date",
    "invalid_to_date": "Please enter a valid date",
    "invalid_date_range": "Please enter a valid from date range",
    "invalid_from_future_date": "Future date is not allowed",
    "invalid_to_future_date": "Future date is not allowed",
    "invalid_date": "Please enter a valid date",
    "invalid_future_date": "Future date is not allowed",
    "saveFilterErrorMsg": "Please try again later or contact us",
    "saveFilterCloseBtnText": "Close"
  },
  "api": {
    "URL": "https://www.mocky.io/v2/5b9ba8123000006000f6b3bd",
    "dataset": [
      {
        "updatedDate": "2018-01-27T12:58:39.000+0000",
        "status": "Open",
        "subject": "Sample early case in January",
        "code": "06296959",
        "createdDate": "2018-03-27T12:58:43.000+0000",
        "subData": [
          {
            "updatedDate": "2018-01-27T12:58:39.000+0000",
            "status": "Open",
            "subject": "Sample early case in January",
            "code": "06296959",
            "createdDate": "2018-03-27T12:58:43.000+0000"
          },
          {
            "updatedDate": "2018-01-27T12:58:39.000+0000",
            "status": "Open",
            "subject": "Sample early case in January",
            "code": "06296959",
            "createdDate": "2018-03-27T12:58:43.000+0000"
          },
          {
            "updatedDate": "2018-01-27T12:58:39.000+0000",
            "status": "Open",
            "subject": "Sample early case in January",
            "code": "06296959",
            "createdDate": "2018-03-27T12:58:43.000+0000"
          }
        ],
        "uuid": "1034803828"
      },
      {
        "updatedDate": "2018-03-27T12:23:02.000+0000",
        "subject": "richa test for webiste support Reference ID: rictest-001",
        "product": "Advanced News System, B2BX, MyTR",
        "status": "Open",
        "code": "06296957",
        "createdDate": "2018-03-27T12:22:55.000+0000",
        "uuid": "229790804"
      },
      {
        "updatedDate": "2018-03-27T10:16:08.000+0000",
        "product": "DACS - Data Access Control System for something longer than this",
        "status": "New",
        "code": "06296928",
        "createdDate": "2018-03-27T10:16:09.000+0000",
        "uuid": "-927656571"
      },
      {
        "updatedDate": "2018-03-27T12:04:44.000+0000",
        "subject": "testing for billing account number  Billing Account Number: A-78945613 Account N",
        "product": "B2BX",
        "status": "New",
        "code": "06296881",
        "createdDate": "2018-03-27T07:41:19.000+0000",
        "uuid": "-1114929049"
      },
      {
        "updatedDate": "2018-03-27T07:27:08.000+0000",
        "subject": "testing purpose only  Alternative email address Provided:vikas.ht@thomsonreuters",
        "product": "Thomson Reuters Eikon",
        "status": "New",
        "code": "06296878",
        "createdDate": "2018-03-27T07:27:09.000+0000",
        "uuid": "500253900"
      },
      {
        "updatedDate": "2018-03-27T06:53:52.000+0000",
        "subject": "testing for multiple attachment Reference ID : 1223",
        "product": "MyTR",
        "status": "New",
        "code": "06296869",
        "createdDate": "2018-03-27T06:53:42.000+0000",
        "uuid": "686936170"
      },
      {
        "updatedDate": "2018-03-26T12:28:43.000+0000",
        "subject": "hghg  Alternative email address Provided:test@test.com",
        "product": "Thomson Reuters Eikon",
        "status": "New",
        "code": "06296842",
        "createdDate": "2018-03-26T12:28:44.000+0000",
        "uuid": "-831936518"
      },
      {
        "updatedDate": "2018-03-26T12:19:26.000+0000",
        "subject": "Ci Sou Test Account - Us  Billing Account Number: A-00693231 Account Name: dryxd",
        "product": "B2BX",
        "status": "Open",
        "code": "06296841",
        "createdDate": "2018-03-26T12:19:26.000+0000",
        "uuid": "-1774044216"
      },
      {
        "updatedDate": "2018-03-26T12:13:49.000+0000",
        "subject": "testing only  Billing Account Number: A-00124651 Account Name: test Invoice Numb",
        "product": "B2BX",
        "status": "New",
        "code": "06296840",
        "createdDate": "2018-03-26T12:13:50.000+0000",
        "uuid": "2047275437"
      },
      {
        "updatedDate": "2018-03-26T11:58:38.000+0000",
        "subject": "testing",
        "product": "Thomson Reuters Eikon",
        "status": "New",
        "code": "06296839",
        "createdDate": "2018-03-26T11:58:38.000+0000",
        "uuid": "-1702813768"
      },
      {
        "updatedDate": "2018-03-26T11:03:24.000+0000",
        "subject": "testing purpose only  Billing Account Number: A-01015596 Account Name: abcd Invo",
        "product": "B2BX",
        "status": "New",
        "code": "06296828",
        "createdDate": "2018-03-26T11:03:27.000+0000",
        "uuid": "1038933755"
      },
      {
        "updatedDate": "2018-03-26T10:37:28.000+0000",
        "subject": "testing 4584  Billing Account Number: A-00946382 Account Name: testingac Invoice",
        "product": "B2BX",
        "status": "New",
        "code": "06296827",
        "createdDate": "2018-03-26T10:37:20.000+0000",
        "uuid": "-129977992"
      },
      {
        "updatedDate": "2018-03-26T10:34:16.000+0000",
        "subject": "Testing",
        "product": "Advanced News System",
        "status": "New",
        "code": "06296826",
        "createdDate": "2018-03-26T10:34:12.000+0000",
        "uuid": "-887313602"
      },
      {
        "updatedDate": "2018-03-26T10:32:04.000+0000",
        "subject": "richa test for webiste support Reference ID: rictest-001",
        "product": "Advanced News System",
        "status": "New",
        "code": "06296825",
        "createdDate": "2018-03-26T10:31:59.000+0000",
        "uuid": "1046713856"
      },
      {
        "updatedDate": "2018-03-26T10:05:48.000+0000",
        "subject": "dfsdf",
        "product": "Thomson Reuters Eikon",
        "status": "New",
        "code": "06296821",
        "createdDate": "2018-03-26T10:05:49.000+0000",
        "uuid": "-1786116761"
      },
      {
        "updatedDate": "2018-03-26T09:58:25.000+0000",
        "subject": "chekc",
        "product": "QADirect",
        "status": "New",
        "code": "06296820",
        "createdDate": "2018-03-26T09:58:25.000+0000",
        "uuid": "-171146775"
      },
      {
        "updatedDate": "2018-03-26T09:54:12.000+0000",
        "subject": "testing for billing account number  Billing Account Number: A-78945613 Account N",
        "product": "B2BX",
        "status": "New",
        "code": "06296819",
        "createdDate": "2018-03-26T09:54:13.000+0000",
        "uuid": "37154080"
      },
      {
        "updatedDate": "2018-03-26T06:29:57.000+0000",
        "subject": "testing 4584  Billing Account Number: A-11111111 Account Name: HSBC Invoice Numb",
        "product": "B2BX",
        "status": "New",
        "code": "06296809",
        "createdDate": "2018-03-26T06:29:49.000+0000",
        "uuid": "-19091431"
      },
      {
        "updatedDate": "2018-03-26T06:23:35.000+0000",
        "subject": "testing? Reference ID : 12344",
        "product": "MyTR",
        "status": "New",
        "code": "06296808",
        "createdDate": "2018-03-26T06:09:00.000+0000",
        "uuid": "2088078893"
      },
      {
        "updatedDate": "2018-03-24T14:21:08.000+0000",
        "subject": "testing 4584  Billing Account Number: A-11111111 Account Name: HSBC Invoice Numb",
        "product": "B2BX",
        "status": "New",
        "code": "06296806",
        "createdDate": "2018-03-24T14:20:49.000+0000",
        "uuid": "-498245461"
      },
      {
        "updatedDate": "2018-03-23T14:53:14.000+0000",
        "subject": "last test  Billing Account Number: A-00946382 Account Name:  Invoice Number:",
        "product": "B2BX",
        "status": "New",
        "code": "06296803",
        "createdDate": "2018-03-23T14:53:19.000+0000",
        "uuid": "286555339"
      },
      {
        "updatedDate": "2018-03-23T13:50:47.000+0000",
        "product": "DACS - Data Access Control System",
        "status": "New",
        "code": "06296775",
        "createdDate": "2018-03-23T13:50:47.000+0000",
        "uuid": "-499091237"
      },
      {
        "updatedDate": "2018-03-23T13:43:01.000+0000",
        "subject": "Testing",
        "product": "Advanced News System",
        "status": "New",
        "code": "06296774",
        "createdDate": "2018-03-23T13:42:55.000+0000",
        "uuid": "-78956710"
      },
      {
        "updatedDate": "2018-03-23T09:48:04.000+0000",
        "status": "New",
        "code": "06296747",
        "createdDate": "2018-03-23T09:48:04.000+0000",
        "uuid": "45860969"
      },
      {
        "updatedDate": "2018-03-23T09:45:33.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296746",
        "createdDate": "2018-03-23T09:45:28.000+0000",
        "uuid": "1970206096"
      },
      {
        "updatedDate": "2018-03-23T07:39:31.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296735",
        "createdDate": "2018-03-23T07:38:11.000+0000",
        "uuid": "65599021"
      },
      {
        "updatedDate": "2018-03-23T07:31:40.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296733",
        "createdDate": "2018-03-23T07:30:51.000+0000",
        "uuid": "1240411209"
      },
      {
        "updatedDate": "2018-03-23T06:34:35.000+0000",
        "status": "New",
        "code": "06296729",
        "createdDate": "2018-03-23T06:34:35.000+0000",
        "uuid": "-818498327"
      },
      {
        "updatedDate": "2018-03-23T06:28:15.000+0000",
        "status": "New",
        "code": "06296728",
        "createdDate": "2018-03-23T06:28:15.000+0000",
        "uuid": "630418370"
      },
      {
        "updatedDate": "2018-03-23T06:24:07.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296727",
        "createdDate": "2018-03-23T06:24:02.000+0000",
        "uuid": "1566559880"
      },
      {
        "updatedDate": "2018-03-23T05:58:44.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296726",
        "createdDate": "2018-03-23T05:58:38.000+0000",
        "uuid": "1475119025"
      },
      {
        "updatedDate": "2018-03-23T05:47:53.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296725",
        "createdDate": "2018-03-23T05:47:48.000+0000",
        "uuid": "431459441"
      },
      {
        "updatedDate": "2018-03-23T05:41:58.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296724",
        "createdDate": "2018-03-23T05:41:53.000+0000",
        "uuid": "-160422120"
      },
      {
        "updatedDate": "2018-03-23T05:40:10.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296723",
        "createdDate": "2018-03-23T05:39:57.000+0000",
        "uuid": "1957833090"
      },
      {
        "updatedDate": "2018-03-22T22:54:08.000+0000",
        "product": "QADirect",
        "status": "New",
        "code": "06296719",
        "createdDate": "2018-03-22T22:54:08.000+0000",
        "uuid": "203390960"
      },
      {
        "updatedDate": "2018-03-22T22:45:35.000+0000",
        "product": "QADirect",
        "status": "New",
        "code": "06296718",
        "createdDate": "2018-03-22T22:45:36.000+0000",
        "uuid": "1373671792"
      },
      {
        "updatedDate": "2018-03-22T20:08:36.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296717",
        "createdDate": "2018-03-22T20:08:39.000+0000",
        "uuid": "1408689828"
      },
      {
        "updatedDate": "2018-03-22T14:00:01.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296704",
        "createdDate": "2018-03-22T13:59:55.000+0000",
        "uuid": "-1698701178"
      },
      {
        "updatedDate": "2018-03-22T13:57:54.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296703",
        "createdDate": "2018-03-22T13:57:49.000+0000",
        "uuid": "-1958497500"
      },
      {
        "updatedDate": "2018-03-22T13:56:09.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296702",
        "createdDate": "2018-03-22T13:56:02.000+0000",
        "uuid": "1600802467"
      },
      {
        "updatedDate": "2018-03-22T13:23:11.000+0000",
        "status": "New",
        "code": "06296699",
        "createdDate": "2018-03-22T13:23:11.000+0000",
        "uuid": "973583159"
      },
      {
        "updatedDate": "2018-03-22T12:45:42.000+0000",
        "subject": "My Test Reference ID : 12121",
        "product": "MyTR",
        "status": "New",
        "code": "06296697",
        "createdDate": "2018-03-22T12:45:43.000+0000",
        "uuid": "67007292"
      },
      {
        "updatedDate": "2018-03-22T12:35:47.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296695",
        "createdDate": "2018-03-22T12:35:41.000+0000",
        "uuid": "-43318083"
      },
      {
        "updatedDate": "2018-03-22T12:33:10.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296694",
        "createdDate": "2018-03-22T12:33:04.000+0000",
        "uuid": "2140925594"
      },
      {
        "updatedDate": "2018-03-22T12:31:26.000+0000",
        "subject": "Testing",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296693",
        "createdDate": "2018-03-22T12:31:18.000+0000",
        "uuid": "-1284632546"
      },
      {
        "updatedDate": "2018-03-22T12:07:09.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296691",
        "createdDate": "2018-03-22T12:07:02.000+0000",
        "uuid": "-372526728"
      },
      {
        "updatedDate": "2018-03-22T12:04:58.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296690",
        "createdDate": "2018-03-22T12:04:51.000+0000",
        "uuid": "910376618"
      },
      {
        "updatedDate": "2018-03-22T11:33:06.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296689",
        "createdDate": "2018-03-22T11:33:06.000+0000",
        "uuid": "185110907"
      },
      {
        "updatedDate": "2018-03-22T11:29:33.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296688",
        "createdDate": "2018-03-22T11:29:34.000+0000",
        "uuid": "202033051"
      },
      {
        "updatedDate": "2018-03-22T11:28:02.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296687",
        "createdDate": "2018-03-22T11:28:02.000+0000",
        "uuid": "1255735929"
      },
      {
        "updatedDate": "2018-03-22T11:20:50.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296685",
        "createdDate": "2018-03-22T11:20:51.000+0000",
        "uuid": "-1767841608"
      },
      {
        "updatedDate": "2018-03-22T10:53:56.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296684",
        "createdDate": "2018-03-22T10:53:57.000+0000",
        "uuid": "-1193592329"
      },
      {
        "updatedDate": "2018-03-22T10:50:38.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296683",
        "createdDate": "2018-03-22T10:50:39.000+0000",
        "uuid": "-1722141962"
      },
      {
        "updatedDate": "2018-03-22T10:46:55.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296682",
        "createdDate": "2018-03-22T10:46:56.000+0000",
        "uuid": "1438844501"
      },
      {
        "updatedDate": "2018-03-22T10:38:36.000+0000",
        "subject": "My Test Reference ID : 12121",
        "product": "MyTR",
        "status": "New",
        "code": "06296681",
        "createdDate": "2018-03-22T10:38:40.000+0000",
        "uuid": "-1875099315"
      },
      {
        "updatedDate": "2018-03-22T09:39:00.000+0000",
        "status": "New",
        "code": "06296680",
        "createdDate": "2018-03-22T09:38:52.000+0000",
        "uuid": "-933565295"
      },
      {
        "updatedDate": "2018-03-22T09:34:01.000+0000",
        "status": "New",
        "code": "06296679",
        "createdDate": "2018-03-22T09:23:44.000+0000",
        "uuid": "-2044234232"
      },
      {
        "updatedDate": "2018-03-22T09:18:21.000+0000",
        "subject": "My Test Reference ID : 12121",
        "product": "MyTR",
        "status": "New",
        "code": "06296678",
        "createdDate": "2018-03-22T09:18:22.000+0000",
        "uuid": "884834981"
      },
      {
        "updatedDate": "2018-03-22T07:45:38.000+0000",
        "product": "DACS - Data Access Control System",
        "status": "New",
        "code": "06296673",
        "createdDate": "2018-03-22T07:45:38.000+0000",
        "uuid": "679921852"
      },
      {
        "updatedDate": "2018-03-22T07:27:00.000+0000",
        "status": "New",
        "code": "06296671",
        "createdDate": "2018-03-22T07:10:03.000+0000",
        "uuid": "-1506496964"
      },
      {
        "updatedDate": "2018-03-22T06:44:00.000+0000",
        "status": "New",
        "code": "06296669",
        "createdDate": "2018-03-22T06:43:51.000+0000",
        "uuid": "1116398433"
      },
      {
        "updatedDate": "2018-03-22T06:38:38.000+0000",
        "status": "New",
        "code": "06296667",
        "createdDate": "2018-03-22T06:36:55.000+0000",
        "uuid": "-1838842081"
      },
      {
        "updatedDate": "2018-03-22T06:34:49.000+0000",
        "product": "B2BX",
        "status": "Work In Progress",
        "code": "06296666",
        "createdDate": "2018-03-22T06:31:31.000+0000",
        "uuid": "1385775447"
      },
      {
        "updatedDate": "2018-03-22T06:30:00.000+0000",
        "product": "Thomson Reuters Eikon",
        "status": "Work In Progress",
        "code": "06296665",
        "createdDate": "2018-03-22T06:28:51.000+0000",
        "uuid": "-788423131"
      },
      {
        "updatedDate": "2018-03-22T06:27:18.000+0000",
        "status": "New",
        "code": "06296662",
        "createdDate": "2018-03-22T06:27:19.000+0000",
        "uuid": "404177474"
      },
      {
        "updatedDate": "2018-03-22T06:24:58.000+0000",
        "status": "New",
        "code": "06296660",
        "createdDate": "2018-03-22T06:25:02.000+0000",
        "uuid": "-65414885"
      },
      {
        "updatedDate": "2018-03-22T06:21:43.000+0000",
        "status": "New",
        "code": "06296659",
        "createdDate": "2018-03-22T06:19:57.000+0000",
        "uuid": "763462047"
      },
      {
        "updatedDate": "2018-03-22T04:41:22.000+0000",
        "status": "New",
        "code": "06296647",
        "createdDate": "2018-03-22T04:41:28.000+0000",
        "uuid": "-41263284"
      },
      {
        "updatedDate": "2018-03-21T13:11:07.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296638",
        "createdDate": "2018-03-21T13:11:08.000+0000",
        "uuid": "456010624"
      },
      {
        "updatedDate": "2018-03-21T13:05:51.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296637",
        "createdDate": "2018-03-21T13:05:52.000+0000",
        "uuid": "-927286433"
      },
      {
        "updatedDate": "2018-03-21T13:00:10.000+0000",
        "status": "New",
        "code": "06296636",
        "createdDate": "2018-03-21T13:00:11.000+0000",
        "uuid": "1763554429"
      },
      {
        "updatedDate": "2018-03-21T12:12:56.000+0000",
        "status": "New",
        "code": "06296634",
        "createdDate": "2018-03-21T12:12:57.000+0000",
        "uuid": "14795579"
      },
      {
        "updatedDate": "2018-03-21T11:49:35.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296633",
        "createdDate": "2018-03-21T11:49:35.000+0000",
        "uuid": "-1000038470"
      },
      {
        "updatedDate": "2018-03-21T11:50:53.000+0000",
        "status": "New",
        "code": "06296632",
        "createdDate": "2018-03-21T11:38:56.000+0000",
        "uuid": "1998362869"
      },
      {
        "updatedDate": "2018-03-21T11:22:15.000+0000",
        "product": "ADS-Advanced Distribution Server",
        "status": "New",
        "code": "06296631",
        "createdDate": "2018-03-21T11:22:15.000+0000",
        "uuid": "1242424064"
      },
      {
        "updatedDate": "2018-03-21T11:20:36.000+0000",
        "product": "ADH-Advanced Data Hub",
        "status": "New",
        "code": "06296630",
        "createdDate": "2018-03-21T11:20:36.000+0000",
        "uuid": "1192704316"
      },
      {
        "updatedDate": "2018-03-21T11:01:08.000+0000",
        "status": "New",
        "code": "06296628",
        "createdDate": "2018-03-21T11:01:08.000+0000",
        "uuid": "-1090664277"
      },
      {
        "updatedDate": "2018-03-21T10:35:39.000+0000",
        "status": "New",
        "code": "06296627",
        "createdDate": "2018-03-21T10:35:42.000+0000",
        "uuid": "1970804186"
      },
      {
        "updatedDate": "2018-03-21T09:39:03.000+0000",
        "product": "Thomson Reuters Eikon",
        "status": "New",
        "code": "06296624",
        "createdDate": "2018-03-21T09:39:04.000+0000",
        "uuid": "-578105505"
      },
      {
        "updatedDate": "2018-03-21T11:28:13.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296623",
        "createdDate": "2018-03-21T09:21:50.000+0000",
        "uuid": "-2022049391"
      },
      {
        "updatedDate": "2018-03-21T09:21:41.000+0000",
        "status": "New",
        "code": "06296622",
        "createdDate": "2018-03-21T09:20:48.000+0000",
        "uuid": "-1701256755"
      },
      {
        "updatedDate": "2018-03-21T09:19:55.000+0000",
        "status": "New",
        "code": "06296620",
        "createdDate": "2018-03-21T09:18:11.000+0000",
        "uuid": "515941592"
      },
      {
        "updatedDate": "2018-03-21T09:30:19.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296619",
        "createdDate": "2018-03-21T08:52:58.000+0000",
        "uuid": "848072412"
      },
      {
        "updatedDate": "2018-03-21T08:17:35.000+0000",
        "product": "DACS - Data Access Control System",
        "status": "New",
        "code": "06296617",
        "createdDate": "2018-03-21T08:17:36.000+0000",
        "uuid": "71730715"
      },
      {
        "updatedDate": "2018-03-21T07:56:40.000+0000",
        "product": "QADirect",
        "status": "New",
        "code": "06296616",
        "createdDate": "2018-03-21T07:56:41.000+0000",
        "uuid": "2118580237"
      },
      {
        "updatedDate": "2018-03-21T07:56:05.000+0000",
        "product": "DACS - Data Access Control System",
        "status": "New",
        "code": "06296615",
        "createdDate": "2018-03-21T07:56:06.000+0000",
        "uuid": "-345082329"
      },
      {
        "updatedDate": "2018-03-21T07:55:38.000+0000",
        "product": "Thomson Reuters Eikon",
        "status": "New",
        "code": "06296614",
        "createdDate": "2018-03-21T07:55:38.000+0000",
        "uuid": "1770881291"
      },
      {
        "updatedDate": "2018-03-21T07:55:56.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296613",
        "createdDate": "2018-03-21T07:55:14.000+0000",
        "uuid": "1024948267"
      },
      {
        "updatedDate": "2018-03-21T07:44:11.000+0000",
        "product": "QADirect",
        "status": "New",
        "code": "06296612",
        "createdDate": "2018-03-21T07:44:11.000+0000",
        "uuid": "1380914888"
      },
      {
        "updatedDate": "2018-03-21T07:36:19.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296610",
        "createdDate": "2018-03-21T07:36:11.000+0000",
        "uuid": "-450336898"
      },
      {
        "updatedDate": "2018-03-21T07:32:35.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296609",
        "createdDate": "2018-03-21T07:32:36.000+0000",
        "uuid": "41471876"
      },
      {
        "updatedDate": "2018-03-21T07:31:07.000+0000",
        "status": "New",
        "code": "06296608",
        "createdDate": "2018-03-21T07:31:07.000+0000",
        "uuid": "145285759"
      },
      {
        "updatedDate": "2018-03-21T07:30:31.000+0000",
        "product": "ADH-Advanced Data Hub",
        "status": "New",
        "code": "06296607",
        "createdDate": "2018-03-21T07:30:32.000+0000",
        "uuid": "909250253"
      },
      {
        "updatedDate": "2018-03-21T07:02:58.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296604",
        "createdDate": "2018-03-21T07:02:14.000+0000",
        "uuid": "-233763061"
      },
      {
        "updatedDate": "2018-03-21T06:59:51.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296600",
        "createdDate": "2018-03-21T06:59:46.000+0000",
        "uuid": "-624662547"
      },
      {
        "updatedDate": "2018-03-21T06:56:54.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296598",
        "createdDate": "2018-03-21T06:56:45.000+0000",
        "uuid": "118365639"
      },
      {
        "updatedDate": "2018-03-21T06:43:16.000+0000",
        "status": "New",
        "code": "06296590",
        "createdDate": "2018-03-21T06:43:16.000+0000",
        "uuid": "-864409147"
      },
      {
        "updatedDate": "2018-03-21T06:29:59.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296588",
        "createdDate": "2018-03-21T06:30:00.000+0000",
        "uuid": "-678458113"
      },
      {
        "updatedDate": "2018-03-21T06:22:03.000+0000",
        "status": "New",
        "code": "06296587",
        "createdDate": "2018-03-21T06:22:03.000+0000",
        "uuid": "1295601959"
      },
      {
        "updatedDate": "2018-03-21T06:11:43.000+0000",
        "subject": "My Test Reference ID : 12121",
        "product": "MyTR",
        "status": "New",
        "code": "06296586",
        "createdDate": "2018-03-21T06:11:44.000+0000",
        "uuid": "2005280075"
      }
    ],
    "filteredDataSet": [
      {
        "updatedDate": "2018-01-27T12:58:39.000+0000",
        "status": "Open",
        "subject": "Sample early case in January",
        "code": "06296959",
        "createdDate": "2018-03-27T12:58:43.000+0000",
        "subData": [
          {
            "updatedDate": "2018-01-27T12:58:39.000+0000",
            "status": "Open",
            "subject": "Sample early case in January",
            "code": "06296959",
            "createdDate": "2018-03-27T12:58:43.000+0000"
          },
          {
            "updatedDate": "2018-01-27T12:58:39.000+0000",
            "status": "Open",
            "subject": "Sample early case in January",
            "code": "06296959",
            "createdDate": "2018-03-27T12:58:43.000+0000"
          },
          {
            "updatedDate": "2018-01-27T12:58:39.000+0000",
            "status": "Open",
            "subject": "Sample early case in January",
            "code": "06296959",
            "createdDate": "2018-03-27T12:58:43.000+0000"
          }
        ],
        "uuid": "1034803828"
      },
      {
        "updatedDate": "2018-03-27T12:23:02.000+0000",
        "subject": "richa test for webiste support Reference ID: rictest-001",
        "product": "Advanced News System, B2BX, MyTR",
        "status": "Open",
        "code": "06296957",
        "createdDate": "2018-03-27T12:22:55.000+0000",
        "uuid": "229790804"
      },
      {
        "updatedDate": "2018-03-27T10:16:08.000+0000",
        "product": "DACS - Data Access Control System for something longer than this",
        "status": "New",
        "code": "06296928",
        "createdDate": "2018-03-27T10:16:09.000+0000",
        "uuid": "-927656571"
      },
      {
        "updatedDate": "2018-03-27T12:04:44.000+0000",
        "subject": "testing for billing account number  Billing Account Number: A-78945613 Account N",
        "product": "B2BX",
        "status": "New",
        "code": "06296881",
        "createdDate": "2018-03-27T07:41:19.000+0000",
        "uuid": "-1114929049"
      },
      {
        "updatedDate": "2018-03-27T07:27:08.000+0000",
        "subject": "testing purpose only  Alternative email address Provided:vikas.ht@thomsonreuters",
        "product": "Thomson Reuters Eikon",
        "status": "New",
        "code": "06296878",
        "createdDate": "2018-03-27T07:27:09.000+0000",
        "uuid": "500253900"
      },
      {
        "updatedDate": "2018-03-27T06:53:52.000+0000",
        "subject": "testing for multiple attachment Reference ID : 1223",
        "product": "MyTR",
        "status": "New",
        "code": "06296869",
        "createdDate": "2018-03-27T06:53:42.000+0000",
        "uuid": "686936170"
      },
      {
        "updatedDate": "2018-03-26T12:28:43.000+0000",
        "subject": "hghg  Alternative email address Provided:test@test.com",
        "product": "Thomson Reuters Eikon",
        "status": "New",
        "code": "06296842",
        "createdDate": "2018-03-26T12:28:44.000+0000",
        "uuid": "-831936518"
      },
      {
        "updatedDate": "2018-03-26T12:19:26.000+0000",
        "subject": "Ci Sou Test Account - Us  Billing Account Number: A-00693231 Account Name: dryxd",
        "product": "B2BX",
        "status": "Open",
        "code": "06296841",
        "createdDate": "2018-03-26T12:19:26.000+0000",
        "uuid": "-1774044216"
      },
      {
        "updatedDate": "2018-03-26T12:13:49.000+0000",
        "subject": "testing only  Billing Account Number: A-00124651 Account Name: test Invoice Numb",
        "product": "B2BX",
        "status": "New",
        "code": "06296840",
        "createdDate": "2018-03-26T12:13:50.000+0000",
        "uuid": "2047275437"
      },
      {
        "updatedDate": "2018-03-26T11:58:38.000+0000",
        "subject": "testing",
        "product": "Thomson Reuters Eikon",
        "status": "New",
        "code": "06296839",
        "createdDate": "2018-03-26T11:58:38.000+0000",
        "uuid": "-1702813768"
      },
      {
        "updatedDate": "2018-03-26T11:03:24.000+0000",
        "subject": "testing purpose only  Billing Account Number: A-01015596 Account Name: abcd Invo",
        "product": "B2BX",
        "status": "New",
        "code": "06296828",
        "createdDate": "2018-03-26T11:03:27.000+0000",
        "uuid": "1038933755"
      },
      {
        "updatedDate": "2018-03-26T10:37:28.000+0000",
        "subject": "testing 4584  Billing Account Number: A-00946382 Account Name: testingac Invoice",
        "product": "B2BX",
        "status": "New",
        "code": "06296827",
        "createdDate": "2018-03-26T10:37:20.000+0000",
        "uuid": "-129977992"
      },
      {
        "updatedDate": "2018-03-26T10:34:16.000+0000",
        "subject": "Testing",
        "product": "Advanced News System",
        "status": "New",
        "code": "06296826",
        "createdDate": "2018-03-26T10:34:12.000+0000",
        "uuid": "-887313602"
      },
      {
        "updatedDate": "2018-03-26T10:32:04.000+0000",
        "subject": "richa test for webiste support Reference ID: rictest-001",
        "product": "Advanced News System",
        "status": "New",
        "code": "06296825",
        "createdDate": "2018-03-26T10:31:59.000+0000",
        "uuid": "1046713856"
      },
      {
        "updatedDate": "2018-03-26T10:05:48.000+0000",
        "subject": "dfsdf",
        "product": "Thomson Reuters Eikon",
        "status": "New",
        "code": "06296821",
        "createdDate": "2018-03-26T10:05:49.000+0000",
        "uuid": "-1786116761"
      },
      {
        "updatedDate": "2018-03-26T09:58:25.000+0000",
        "subject": "chekc",
        "product": "QADirect",
        "status": "New",
        "code": "06296820",
        "createdDate": "2018-03-26T09:58:25.000+0000",
        "uuid": "-171146775"
      },
      {
        "updatedDate": "2018-03-26T09:54:12.000+0000",
        "subject": "testing for billing account number  Billing Account Number: A-78945613 Account N",
        "product": "B2BX",
        "status": "New",
        "code": "06296819",
        "createdDate": "2018-03-26T09:54:13.000+0000",
        "uuid": "37154080"
      },
      {
        "updatedDate": "2018-03-26T06:29:57.000+0000",
        "subject": "testing 4584  Billing Account Number: A-11111111 Account Name: HSBC Invoice Numb",
        "product": "B2BX",
        "status": "New",
        "code": "06296809",
        "createdDate": "2018-03-26T06:29:49.000+0000",
        "uuid": "-19091431"
      },
      {
        "updatedDate": "2018-03-26T06:23:35.000+0000",
        "subject": "testing? Reference ID : 12344",
        "product": "MyTR",
        "status": "New",
        "code": "06296808",
        "createdDate": "2018-03-26T06:09:00.000+0000",
        "uuid": "2088078893"
      },
      {
        "updatedDate": "2018-03-24T14:21:08.000+0000",
        "subject": "testing 4584  Billing Account Number: A-11111111 Account Name: HSBC Invoice Numb",
        "product": "B2BX",
        "status": "New",
        "code": "06296806",
        "createdDate": "2018-03-24T14:20:49.000+0000",
        "uuid": "-498245461"
      },
      {
        "updatedDate": "2018-03-23T14:53:14.000+0000",
        "subject": "last test  Billing Account Number: A-00946382 Account Name:  Invoice Number:",
        "product": "B2BX",
        "status": "New",
        "code": "06296803",
        "createdDate": "2018-03-23T14:53:19.000+0000",
        "uuid": "286555339"
      },
      {
        "updatedDate": "2018-03-23T13:50:47.000+0000",
        "product": "DACS - Data Access Control System",
        "status": "New",
        "code": "06296775",
        "createdDate": "2018-03-23T13:50:47.000+0000",
        "uuid": "-499091237"
      },
      {
        "updatedDate": "2018-03-23T13:43:01.000+0000",
        "subject": "Testing",
        "product": "Advanced News System",
        "status": "New",
        "code": "06296774",
        "createdDate": "2018-03-23T13:42:55.000+0000",
        "uuid": "-78956710"
      },
      {
        "updatedDate": "2018-03-23T09:48:04.000+0000",
        "status": "New",
        "code": "06296747",
        "createdDate": "2018-03-23T09:48:04.000+0000",
        "uuid": "45860969"
      },
      {
        "updatedDate": "2018-03-23T09:45:33.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296746",
        "createdDate": "2018-03-23T09:45:28.000+0000",
        "uuid": "1970206096"
      },
      {
        "updatedDate": "2018-03-23T07:39:31.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296735",
        "createdDate": "2018-03-23T07:38:11.000+0000",
        "uuid": "65599021"
      },
      {
        "updatedDate": "2018-03-23T07:31:40.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296733",
        "createdDate": "2018-03-23T07:30:51.000+0000",
        "uuid": "1240411209"
      },
      {
        "updatedDate": "2018-03-23T06:34:35.000+0000",
        "status": "New",
        "code": "06296729",
        "createdDate": "2018-03-23T06:34:35.000+0000",
        "uuid": "-818498327"
      },
      {
        "updatedDate": "2018-03-23T06:28:15.000+0000",
        "status": "New",
        "code": "06296728",
        "createdDate": "2018-03-23T06:28:15.000+0000",
        "uuid": "630418370"
      },
      {
        "updatedDate": "2018-03-23T06:24:07.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296727",
        "createdDate": "2018-03-23T06:24:02.000+0000",
        "uuid": "1566559880"
      },
      {
        "updatedDate": "2018-03-23T05:58:44.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296726",
        "createdDate": "2018-03-23T05:58:38.000+0000",
        "uuid": "1475119025"
      },
      {
        "updatedDate": "2018-03-23T05:47:53.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296725",
        "createdDate": "2018-03-23T05:47:48.000+0000",
        "uuid": "431459441"
      },
      {
        "updatedDate": "2018-03-23T05:41:58.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296724",
        "createdDate": "2018-03-23T05:41:53.000+0000",
        "uuid": "-160422120"
      },
      {
        "updatedDate": "2018-03-23T05:40:10.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296723",
        "createdDate": "2018-03-23T05:39:57.000+0000",
        "uuid": "1957833090"
      },
      {
        "updatedDate": "2018-03-22T22:54:08.000+0000",
        "product": "QADirect",
        "status": "New",
        "code": "06296719",
        "createdDate": "2018-03-22T22:54:08.000+0000",
        "uuid": "203390960"
      },
      {
        "updatedDate": "2018-03-22T22:45:35.000+0000",
        "product": "QADirect",
        "status": "New",
        "code": "06296718",
        "createdDate": "2018-03-22T22:45:36.000+0000",
        "uuid": "1373671792"
      },
      {
        "updatedDate": "2018-03-22T20:08:36.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296717",
        "createdDate": "2018-03-22T20:08:39.000+0000",
        "uuid": "1408689828"
      },
      {
        "updatedDate": "2018-03-22T14:00:01.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296704",
        "createdDate": "2018-03-22T13:59:55.000+0000",
        "uuid": "-1698701178"
      },
      {
        "updatedDate": "2018-03-22T13:57:54.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296703",
        "createdDate": "2018-03-22T13:57:49.000+0000",
        "uuid": "-1958497500"
      },
      {
        "updatedDate": "2018-03-22T13:56:09.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296702",
        "createdDate": "2018-03-22T13:56:02.000+0000",
        "uuid": "1600802467"
      },
      {
        "updatedDate": "2018-03-22T13:23:11.000+0000",
        "status": "New",
        "code": "06296699",
        "createdDate": "2018-03-22T13:23:11.000+0000",
        "uuid": "973583159"
      },
      {
        "updatedDate": "2018-03-22T12:45:42.000+0000",
        "subject": "My Test Reference ID : 12121",
        "product": "MyTR",
        "status": "New",
        "code": "06296697",
        "createdDate": "2018-03-22T12:45:43.000+0000",
        "uuid": "67007292"
      },
      {
        "updatedDate": "2018-03-22T12:35:47.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296695",
        "createdDate": "2018-03-22T12:35:41.000+0000",
        "uuid": "-43318083"
      },
      {
        "updatedDate": "2018-03-22T12:33:10.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296694",
        "createdDate": "2018-03-22T12:33:04.000+0000",
        "uuid": "2140925594"
      },
      {
        "updatedDate": "2018-03-22T12:31:26.000+0000",
        "subject": "Testing",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296693",
        "createdDate": "2018-03-22T12:31:18.000+0000",
        "uuid": "-1284632546"
      },
      {
        "updatedDate": "2018-03-22T12:07:09.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296691",
        "createdDate": "2018-03-22T12:07:02.000+0000",
        "uuid": "-372526728"
      },
      {
        "updatedDate": "2018-03-22T12:04:58.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296690",
        "createdDate": "2018-03-22T12:04:51.000+0000",
        "uuid": "910376618"
      },
      {
        "updatedDate": "2018-03-22T11:33:06.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296689",
        "createdDate": "2018-03-22T11:33:06.000+0000",
        "uuid": "185110907"
      },
      {
        "updatedDate": "2018-03-22T11:29:33.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296688",
        "createdDate": "2018-03-22T11:29:34.000+0000",
        "uuid": "202033051"
      },
      {
        "updatedDate": "2018-03-22T11:28:02.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296687",
        "createdDate": "2018-03-22T11:28:02.000+0000",
        "uuid": "1255735929"
      },
      {
        "updatedDate": "2018-03-22T11:20:50.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296685",
        "createdDate": "2018-03-22T11:20:51.000+0000",
        "uuid": "-1767841608"
      },
      {
        "updatedDate": "2018-03-22T10:53:56.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296684",
        "createdDate": "2018-03-22T10:53:57.000+0000",
        "uuid": "-1193592329"
      },
      {
        "updatedDate": "2018-03-22T10:50:38.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296683",
        "createdDate": "2018-03-22T10:50:39.000+0000",
        "uuid": "-1722141962"
      },
      {
        "updatedDate": "2018-03-22T10:46:55.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296682",
        "createdDate": "2018-03-22T10:46:56.000+0000",
        "uuid": "1438844501"
      },
      {
        "updatedDate": "2018-03-22T10:38:36.000+0000",
        "subject": "My Test Reference ID : 12121",
        "product": "MyTR",
        "status": "New",
        "code": "06296681",
        "createdDate": "2018-03-22T10:38:40.000+0000",
        "uuid": "-1875099315"
      },
      {
        "updatedDate": "2018-03-22T09:39:00.000+0000",
        "status": "New",
        "code": "06296680",
        "createdDate": "2018-03-22T09:38:52.000+0000",
        "uuid": "-933565295"
      },
      {
        "updatedDate": "2018-03-22T09:34:01.000+0000",
        "status": "New",
        "code": "06296679",
        "createdDate": "2018-03-22T09:23:44.000+0000",
        "uuid": "-2044234232"
      },
      {
        "updatedDate": "2018-03-22T09:18:21.000+0000",
        "subject": "My Test Reference ID : 12121",
        "product": "MyTR",
        "status": "New",
        "code": "06296678",
        "createdDate": "2018-03-22T09:18:22.000+0000",
        "uuid": "884834981"
      },
      {
        "updatedDate": "2018-03-22T07:45:38.000+0000",
        "product": "DACS - Data Access Control System",
        "status": "New",
        "code": "06296673",
        "createdDate": "2018-03-22T07:45:38.000+0000",
        "uuid": "679921852"
      },
      {
        "updatedDate": "2018-03-22T07:27:00.000+0000",
        "status": "New",
        "code": "06296671",
        "createdDate": "2018-03-22T07:10:03.000+0000",
        "uuid": "-1506496964"
      },
      {
        "updatedDate": "2018-03-22T06:44:00.000+0000",
        "status": "New",
        "code": "06296669",
        "createdDate": "2018-03-22T06:43:51.000+0000",
        "uuid": "1116398433"
      },
      {
        "updatedDate": "2018-03-22T06:38:38.000+0000",
        "status": "New",
        "code": "06296667",
        "createdDate": "2018-03-22T06:36:55.000+0000",
        "uuid": "-1838842081"
      },
      {
        "updatedDate": "2018-03-22T06:34:49.000+0000",
        "product": "B2BX",
        "status": "Work In Progress",
        "code": "06296666",
        "createdDate": "2018-03-22T06:31:31.000+0000",
        "uuid": "1385775447"
      },
      {
        "updatedDate": "2018-03-22T06:30:00.000+0000",
        "product": "Thomson Reuters Eikon",
        "status": "Work In Progress",
        "code": "06296665",
        "createdDate": "2018-03-22T06:28:51.000+0000",
        "uuid": "-788423131"
      },
      {
        "updatedDate": "2018-03-22T06:27:18.000+0000",
        "status": "New",
        "code": "06296662",
        "createdDate": "2018-03-22T06:27:19.000+0000",
        "uuid": "404177474"
      },
      {
        "updatedDate": "2018-03-22T06:24:58.000+0000",
        "status": "New",
        "code": "06296660",
        "createdDate": "2018-03-22T06:25:02.000+0000",
        "uuid": "-65414885"
      },
      {
        "updatedDate": "2018-03-22T06:21:43.000+0000",
        "status": "New",
        "code": "06296659",
        "createdDate": "2018-03-22T06:19:57.000+0000",
        "uuid": "763462047"
      },
      {
        "updatedDate": "2018-03-22T04:41:22.000+0000",
        "status": "New",
        "code": "06296647",
        "createdDate": "2018-03-22T04:41:28.000+0000",
        "uuid": "-41263284"
      },
      {
        "updatedDate": "2018-03-21T13:11:07.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296638",
        "createdDate": "2018-03-21T13:11:08.000+0000",
        "uuid": "456010624"
      },
      {
        "updatedDate": "2018-03-21T13:05:51.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296637",
        "createdDate": "2018-03-21T13:05:52.000+0000",
        "uuid": "-927286433"
      },
      {
        "updatedDate": "2018-03-21T13:00:10.000+0000",
        "status": "New",
        "code": "06296636",
        "createdDate": "2018-03-21T13:00:11.000+0000",
        "uuid": "1763554429"
      },
      {
        "updatedDate": "2018-03-21T12:12:56.000+0000",
        "status": "New",
        "code": "06296634",
        "createdDate": "2018-03-21T12:12:57.000+0000",
        "uuid": "14795579"
      },
      {
        "updatedDate": "2018-03-21T11:49:35.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296633",
        "createdDate": "2018-03-21T11:49:35.000+0000",
        "uuid": "-1000038470"
      },
      {
        "updatedDate": "2018-03-21T11:50:53.000+0000",
        "status": "New",
        "code": "06296632",
        "createdDate": "2018-03-21T11:38:56.000+0000",
        "uuid": "1998362869"
      },
      {
        "updatedDate": "2018-03-21T11:22:15.000+0000",
        "product": "ADS-Advanced Distribution Server",
        "status": "New",
        "code": "06296631",
        "createdDate": "2018-03-21T11:22:15.000+0000",
        "uuid": "1242424064"
      },
      {
        "updatedDate": "2018-03-21T11:20:36.000+0000",
        "product": "ADH-Advanced Data Hub",
        "status": "New",
        "code": "06296630",
        "createdDate": "2018-03-21T11:20:36.000+0000",
        "uuid": "1192704316"
      },
      {
        "updatedDate": "2018-03-21T11:01:08.000+0000",
        "status": "New",
        "code": "06296628",
        "createdDate": "2018-03-21T11:01:08.000+0000",
        "uuid": "-1090664277"
      },
      {
        "updatedDate": "2018-03-21T10:35:39.000+0000",
        "status": "New",
        "code": "06296627",
        "createdDate": "2018-03-21T10:35:42.000+0000",
        "uuid": "1970804186"
      },
      {
        "updatedDate": "2018-03-21T09:39:03.000+0000",
        "product": "Thomson Reuters Eikon",
        "status": "New",
        "code": "06296624",
        "createdDate": "2018-03-21T09:39:04.000+0000",
        "uuid": "-578105505"
      },
      {
        "updatedDate": "2018-03-21T11:28:13.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296623",
        "createdDate": "2018-03-21T09:21:50.000+0000",
        "uuid": "-2022049391"
      },
      {
        "updatedDate": "2018-03-21T09:21:41.000+0000",
        "status": "New",
        "code": "06296622",
        "createdDate": "2018-03-21T09:20:48.000+0000",
        "uuid": "-1701256755"
      },
      {
        "updatedDate": "2018-03-21T09:19:55.000+0000",
        "status": "New",
        "code": "06296620",
        "createdDate": "2018-03-21T09:18:11.000+0000",
        "uuid": "515941592"
      },
      {
        "updatedDate": "2018-03-21T09:30:19.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296619",
        "createdDate": "2018-03-21T08:52:58.000+0000",
        "uuid": "848072412"
      },
      {
        "updatedDate": "2018-03-21T08:17:35.000+0000",
        "product": "DACS - Data Access Control System",
        "status": "New",
        "code": "06296617",
        "createdDate": "2018-03-21T08:17:36.000+0000",
        "uuid": "71730715"
      },
      {
        "updatedDate": "2018-03-21T07:56:40.000+0000",
        "product": "QADirect",
        "status": "New",
        "code": "06296616",
        "createdDate": "2018-03-21T07:56:41.000+0000",
        "uuid": "2118580237"
      },
      {
        "updatedDate": "2018-03-21T07:56:05.000+0000",
        "product": "DACS - Data Access Control System",
        "status": "New",
        "code": "06296615",
        "createdDate": "2018-03-21T07:56:06.000+0000",
        "uuid": "-345082329"
      },
      {
        "updatedDate": "2018-03-21T07:55:38.000+0000",
        "product": "Thomson Reuters Eikon",
        "status": "New",
        "code": "06296614",
        "createdDate": "2018-03-21T07:55:38.000+0000",
        "uuid": "1770881291"
      },
      {
        "updatedDate": "2018-03-21T07:55:56.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296613",
        "createdDate": "2018-03-21T07:55:14.000+0000",
        "uuid": "1024948267"
      },
      {
        "updatedDate": "2018-03-21T07:44:11.000+0000",
        "product": "QADirect",
        "status": "New",
        "code": "06296612",
        "createdDate": "2018-03-21T07:44:11.000+0000",
        "uuid": "1380914888"
      },
      {
        "updatedDate": "2018-03-21T07:36:19.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296610",
        "createdDate": "2018-03-21T07:36:11.000+0000",
        "uuid": "-450336898"
      },
      {
        "updatedDate": "2018-03-21T07:32:35.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296609",
        "createdDate": "2018-03-21T07:32:36.000+0000",
        "uuid": "41471876"
      },
      {
        "updatedDate": "2018-03-21T07:31:07.000+0000",
        "status": "New",
        "code": "06296608",
        "createdDate": "2018-03-21T07:31:07.000+0000",
        "uuid": "145285759"
      },
      {
        "updatedDate": "2018-03-21T07:30:31.000+0000",
        "product": "ADH-Advanced Data Hub",
        "status": "New",
        "code": "06296607",
        "createdDate": "2018-03-21T07:30:32.000+0000",
        "uuid": "909250253"
      },
      {
        "updatedDate": "2018-03-21T07:02:58.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296604",
        "createdDate": "2018-03-21T07:02:14.000+0000",
        "uuid": "-233763061"
      },
      {
        "updatedDate": "2018-03-21T06:59:51.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296600",
        "createdDate": "2018-03-21T06:59:46.000+0000",
        "uuid": "-624662547"
      },
      {
        "updatedDate": "2018-03-21T06:56:54.000+0000",
        "product": "Advanced Transformation System (ATS)",
        "status": "New",
        "code": "06296598",
        "createdDate": "2018-03-21T06:56:45.000+0000",
        "uuid": "118365639"
      },
      {
        "updatedDate": "2018-03-21T06:43:16.000+0000",
        "status": "New",
        "code": "06296590",
        "createdDate": "2018-03-21T06:43:16.000+0000",
        "uuid": "-864409147"
      },
      {
        "updatedDate": "2018-03-21T06:29:59.000+0000",
        "product": "B2BX",
        "status": "New",
        "code": "06296588",
        "createdDate": "2018-03-21T06:30:00.000+0000",
        "uuid": "-678458113"
      },
      {
        "updatedDate": "2018-03-21T06:22:03.000+0000",
        "status": "New",
        "code": "06296587",
        "createdDate": "2018-03-21T06:22:03.000+0000",
        "uuid": "1295601959"
      },
      {
        "updatedDate": "2018-03-21T06:11:43.000+0000",
        "subject": "My Test Reference ID : 12121",
        "product": "MyTR",
        "status": "New",
        "code": "06296586",
        "createdDate": "2018-03-21T06:11:44.000+0000",
        "uuid": "2005280075"
      }
    ],
    "toggleDataSet": null,
    "postLoadCallback": {
      "callback": "postLoadCallback"
    },
    "serverSideFilteringObject": null,
    "sortEngine": "client",
    "endpointParams": {},
    "_sort": null,
    "pagination": {
      "_page": 1,
      "offset": 1,
      "pagesize": 10
    },
    "basicPaginationEnabled": false,
    "moreItems": false,
    "lessItems": false,
    "moreItemsTableID": null,
    "lessItemsTableID": null,
    "paginationButtonClicked": null,
    "filters": {},
    "customFilter": null,
    "customFilterId": null,
    "customFilterType": null,
    "_search": null,
    "_toggleFilter": null,
    "_advancedFilters": null,
    "_totalItems": 100,
    "env": {
      "path": "TR_pageFunctions.component1"
    },
    "selectedRows": [],
    "allRowsSelected": false
  },
  "saveFiltersChecked": false,
  "appliedFilters": {},
  "events": {},
  "validationErrors": false
}